var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:'col-custom-'+ _vm.css},[_c('b-tooltip',{attrs:{"label":_vm.currentEtichetta}},[_vm._v("\n  "+_vm._s(this.currentEtichetta)+"\n  ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }